export const SELECT = 'SELECT_BIRTH_DATE';
export const DEFAULT = 'DEFAULT_BIRTH_DATE';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_BIRTH_DATE';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_BIRTH_DATE';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_BIRTH_DATE';
export const TOGGLE_VISIBILITY = 'TOGGLE_VISIBILITY_BIRTH_DATE';
export const HIDE = 'HIDE_BIRTH_DATE';
export const SHOW = 'SHOW_BIRTH_DATE';
export const SET_YEAR = 'SET_YEAR_BIRTH_DATE';
export const SET_MONTH = 'SET_MONTH_BIRTH_DATE';
export const SET_DATE = 'SET_DATE';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}

